import { useState, useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_TVC_API_URL;

function validateNavbarData(data) {
  if (!data || typeof data !== "object") return null;
  return {
    toolLinks: Array.isArray(data.toolLinks) ? data.toolLinks : [],
    toolImages: data.toolImages && typeof data.toolImages === "object" ? data.toolImages : {},
    tabs: Array.isArray(data.tabs) ? data.tabs : [],
    mobileMenuLinks: Array.isArray(data.mobileMenuLinks) ? data.mobileMenuLinks : [],
    mobileQuickActions: Array.isArray(data.mobileQuickActions) ? data.mobileQuickActions : [],
    brand: data.brand && typeof data.brand === "object" ? data.brand : {},
    whatsapp: data.whatsapp && typeof data.whatsapp === "object" ? data.whatsapp : {},
    calendar: data.calendar && typeof data.calendar === "object" ? data.calendar : {},
  };
}

export function useNavbarData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/content/navbar`);
        if (!res.ok) {
          setError("Failed to fetch navbar content");
          return;
        }
        const json = await res.json();
        if (!cancelled && json && json.section && json.section.content) {
          const validated = validateNavbarData(json.section.content);
          if (validated) {
            setData(validated);
            setError(null);
          }
        }
      } catch (err) {
        if (!cancelled) setError(err.message);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchData();
    return () => { cancelled = true; };
  }, []);

  return { data, loading, error };
}
